import '@angular/localize/init';
export * from './lib/feature-tax-report-details.module';

export * from './lib/tax-report-details/feature-tax-report-details.component';
